import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "@/components/ErrorBoundary";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Inject PWA manifest/meta dynamically so index.html stays clean for landing page
(function injectPWATags() {
  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = "/manifest.json";
  document.head.appendChild(link);
  const theme = document.createElement("meta");
  theme.name = "theme-color";
  theme.content = "#0a0a0a";
  document.head.appendChild(theme);
  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = "/icons/icon-192.svg";
  document.head.appendChild(apple);
  const appName = document.createElement("meta");
  appName.name = "application-name";
  appName.content = "IQTrade";
  document.head.appendChild(appName);
})();

// Register service worker for PWA support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js");
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
